"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _reactMaterialUiFormValidator = require("react-material-ui-form-validator");
var _answerValidation = require("../../utilities/answerValidation");
var _muiPhoneNumber = _interopRequireDefault(require("../form-controls/mui-phone-number/mui-phone-number"));
var _getCountries = require("../../utilities/getCountries");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CustomPhoneNumberInput = /*#__PURE__*/function (_ValidatorComponent) {
  function CustomPhoneNumberInput(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomPhoneNumberInput);
    _this = _callSuper(this, CustomPhoneNumberInput, [props]);
    _this.state = {
      isValid: true,
      validators: [],
      errorMessage: []
    };
    _this.checkIfValid = _this.checkIfValid.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(CustomPhoneNumberInput, _ValidatorComponent);
  return (0, _createClass2["default"])(CustomPhoneNumberInput, [{
    key: "checkIfValid",
    value: function checkIfValid(value) {
      /* Remove any spaces, dashes and grouping indicators from the phone number */
      var cleanedValue = value.replace(/[ \-\(\)]*/g, '');
      if (cleanedValue.length > 3) {
        var isValid = _answerValidation.customValidationRules.isPhoneNumber(cleanedValue);
        return isValid;
      } else {
        return true;
      }
    }
  }, {
    key: "renderValidatorComponent",
    value: function renderValidatorComponent() {
      var _this$props = this.props,
        className = _this$props.className,
        name = _this$props.name,
        onChange = _this$props.onChange,
        previousValue = _this$props.previousValue,
        value = _this$props.value,
        country = _this$props.country,
        _this$props$shouldVal = _this$props.shouldValidate,
        shouldValidate = _this$props$shouldVal === void 0 ? false : _this$props$shouldVal;

      //issue here is we are not setting the country -- using 'us' for all, when we set to 'my' for malasia the number is formatted correctly
      //so need do do a lookup on country and set preferredCountries and defaultCountry -- this will also fix the flag too
      //if a country is not returning, we can add it to the json in getCountries.js

      var countryCode = 'us';
      if (country) {
        countryCode = (0, _getCountries.getCountries)(country) === undefined ? 'us' : (0, _getCountries.getCountries)(country).toLowerCase();
      }
      // let mask = phoneFormats.find(f => f.region == countryCode).mask;
      console.log('countryCode: ', countryCode);
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_muiPhoneNumber["default"], {
        preferredCountries: [countryCode],
        defaultCountry: countryCode,
        onChange: onChange,
        name: name,
        value: value,
        key: name,
        className: className,
        isValid: shouldValidate ? this.checkIfValid : function () {
          return true;
        }
      }), previousValue && value !== previousValue && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          color: '#207FA0',
          display: 'inline'
        }
      }, "\xA0", previousValue));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var validators = [];
      var errorMessages = [];
      var validationRule = nextProps.validationRule;

      // console.log('in CPN: ', nextProps); //good

      if (!(0, _lodash.isEmpty)(validationRule) && validationRule.validatorFunctionName !== null) {
        validators.push(validationRule.validatorFunctionName);
        errorMessages.push(validationRule.errorMessage);
      }
      if (validators && errorMessages && (prevState.validators !== validators || prevState.errorMessages !== errorMessages)) {
        return {
          value: nextProps.value,
          validators: validators,
          errorMessages: errorMessages
        };
      }
      return {
        value: nextProps.value
      };
    }
  }]);
}(_reactMaterialUiFormValidator.ValidatorComponent);
CustomPhoneNumberInput.propTypes = {
  className: _propTypes["default"].string,
  name: _propTypes["default"].string.isRequired,
  shouldValidate: _propTypes["default"].bool,
  value: _propTypes["default"].string.isRequired,
  previousValue: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  country: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = CustomPhoneNumberInput;